import { getLogger, logger } from 'cadenza/utils/logging';
import { Observable } from 'cadenza/utils/event-util';

/**
 * Basic event bus, meant to share events between different components reducing coupling and the
 * need for the components (in the broader sense, not just Web Components) to obtain instances of
 * each other in order to be able to observe each other.
 *
 * It is based on EventTarget and add a few handy helpers:
 * - ability to log all events through a named logger.
 * - dispatch simple events by name
 */
export class EventBus extends Observable {

  #logger;

  constructor (name: string) {
    super();
    this.#logger = getLogger(name);
    logger.info(`Event Bus "${name}" created. To enable logging of events, paste the following into the console: 
    disyCommons.logger.getLogger('${name}').setLevel('debug');`);
  }

  dispatchEvent (event: Event | string) {
    if (typeof event === 'string') {
      event = new CustomEvent(event);
    }

    if (this.#logger.getLevel() <= logger.levels.DEBUG) {
      this.#logger.debug(`New event on EventBus "${this.#logger.name}":`, event);
    }

    return super.dispatchEvent(event);
  }

  /**
   * Listen for an event once only, then automatically remove the listener.
   *
   * @param type - Type of event
   * @param listener - Listener function
   */
  once (type: string, listener: EventListener) {
    this.addEventListener(type, listener, { once: true });
  }

}

